// TODO: Using monochrome colours until mode tokens are finalised
const themeModeContract = {
  white: {
    background: 'white',
    borderColor: 'base',
    gradientColor: 'white',
    rollover: false,
    button: {
      fontColor: 'darker',
      borderColor: 'black',
      hoverColor: 'dark',
      divider: {
        background: 'base'
      }
    }
  },
  light: {
    background: 'lighter',
    borderColor: 'base',
    gradientColor: 'lighter',
    rollover: false,
    button: {
      fontColor: 'darker',
      borderColor: 'black',
      hoverColor: 'dark',
      divider: {
        background: 'base'
      }
    }
  },
  dark: {
    background: 'darker',
    borderColor: 'darker',
    gradientColor: 'dark',
    rollover: false,
    button: {
      fontColor: 'white',
      borderColor: 'white',
      hoverColor: 'white',
      divider: {
        background: 'dark'
      }
    }
  }
}

const themeContract = {
  tu: {
    themeMode: {
      white: {
        ...themeModeContract.white,
        rollover: true
      },
      light: themeModeContract.light,
      dark: themeModeContract.dark
    }
  },
  argos: {
    themeMode: {
      white: themeModeContract.white,
      light: themeModeContract.light,
      dark: themeModeContract.dark
    }
  },
  habitat: {
    themeMode: {
      white: {
        ...themeModeContract.white,
        rollover: true,
        borderColor: 'light',
        button: {
          ...themeModeContract.white.button,
          hoverColor: 'black',
          divider: {
            background: 'light'
          }
        }
      },
      light: {
        ...themeModeContract.light,
        borderColor: 'light',
        button: {
          ...themeModeContract.light.button,
          hoverColor: 'black',
          divider: {
            background: 'light'
          }
        }
      },
      dark: {
        ...themeModeContract.dark,
        background: 'black',
        borderColor: 'dark',
        button: {
          ...themeModeContract.dark.button,
          fontColor: 'lighter',
          hoverColor: 'white'
        }
      }
    }
  },
  nectar: {
    themeMode: {
      white: themeModeContract.white,
      light: themeModeContract.light,
      dark: themeModeContract.dark
    }
  },
  sainsburys: {
    themeMode: {
      white: themeModeContract.white,
      light: {
        ...themeModeContract.light,
        borderColor: 'light',
        button: {
          ...themeModeContract.light.button,
          divider: {
            background: 'light'
          }
        }
      },
      dark: themeModeContract.dark
    }
  }
}

export { themeContract }
